import { render } from "./SourceOfFunds.vue?vue&type=template&id=01cf0542&scoped=true&ts=true"
import script from "./SourceOfFunds.vue?vue&type=script&lang=ts"
export * from "./SourceOfFunds.vue?vue&type=script&lang=ts"

import "./SourceOfFunds.vue?vue&type=style&index=0&id=01cf0542&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cf0542"],['__file',"src/components/kyc/SourceOfFunds.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01cf0542"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01cf0542', __exports__)) {
    api.reload('01cf0542', __exports__)
  }
  
  module.hot.accept("./SourceOfFunds.vue?vue&type=template&id=01cf0542&scoped=true&ts=true", () => {
    api.rerender('01cf0542', render)
  })

}


export default __exports__